import { Container, Box, BoxProps } from '@hover/blueprint';
import React, { useEffect, useRef, useState } from 'react';
import BetterSectionDesktopTabs from './BetterSectionDesktopTabs';
import BetterSectionMobileTabs from './BetterSectionMobileTabs';

const TABS_NAME = [
  'Spot-ON Measurements',
  'Visualize In 3d',
  'BETTER ESTIMATES',
  'Order Directly',
];

const TIMER = 9900;

interface Props extends BoxProps {}

const BetterSectionTabs: React.FC<Props> = props => {
  const [currentTab, setCurrentTab] = useState<string>(TABS_NAME[0]);

  const timerRef: { current: null | ReturnType<typeof setTimeout> } =
    useRef(null);

  const handleChangeTab = () => {
    setCurrentTab(prevTab => {
      const prevTabIndex = TABS_NAME.findIndex(tabName => tabName === prevTab);
      if (prevTabIndex === TABS_NAME.length - 1) {
        return TABS_NAME[0];
      }
      return TABS_NAME[prevTabIndex + 1];
    });
  };

  const resetTimer = (title: string) => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    setCurrentTab(() => {
      timerRef.current = setInterval(handleChangeTab, TIMER);
      return title;
    });
  };

  useEffect(() => {
    timerRef.current = setInterval(handleChangeTab, TIMER);
    return () => clearInterval(timerRef.current as NodeJS.Timeout);
  }, []);

  return (
    <Box
      w="100%"
      flexDir="column"
      alignItems="center"
      mb={{ base: 1000, tablet: '177px' }}
      overflow="hidden"
      {...props}
    >
      <Container maxW="7xl" centerContent>
        <BetterSectionDesktopTabs
          currentTab={currentTab}
          resetTimer={resetTimer}
        />
      </Container>
      <BetterSectionMobileTabs
        currentTab={currentTab}
        resetTimer={resetTimer}
      />
    </Box>
  );
};

export default BetterSectionTabs;
